module.exports = __webpack_public_path__ + "img/corneliu-dumitru.6911fedf.jpeg";